import { CropStyleFillPattern } from "@omnia/shared/generated/enums";
import { RGBColor } from "@omnia/shared/types";
import { CropStyle, DescriptionStyle, } from "../types";
import { StyleRow, StyleRowProps } from "./StyleRow";

export interface DescriptionRowProps {
    crop: CropStyle;
    description: DescriptionStyle;
    onChange: StyleRowProps["onChange"];
}

export const DescriptionRow = ({ crop, description, onChange }: DescriptionRowProps) => {
    const effectiveColor: RGBColor =
        description.color ?? crop.color ?? description.defaultStyle?.color ?? crop.defaultStyle?.color;
    const effectivePattern: CropStyleFillPattern =
        description.pattern ?? crop.pattern ?? description.defaultStyle?.pattern ?? crop.defaultStyle?.pattern;

    return (
        <StyleRow
            className="description"
            effectiveStyle={{ color: effectiveColor, pattern: effectivePattern }}
            initialStyle={{ color: description.initialState.color, pattern: description.initialState.pattern }}
            selectedStyle={{ color: description.color, pattern: description.pattern }}
            label={description.description}
            typeLabel="Description"
            onChange={onChange}
        />
    );
};
